import { ServerInfoCallback } from '@protos/v2/serverinfo';
import { StreamEvent, StreamV2 } from '../StreamV2';

export const streamV2ServerInfoService = (stream: StreamV2) => {
  const eventCallbacks = new Set<ServerInfoCallback>();

  stream.onEvent('server_info', (event: StreamEvent) => {
    const serverInfo = event.asServerInfo();
    if (serverInfo) eventCallbacks.forEach(callback => callback(serverInfo));
  });

  const subscribe = (callback: ServerInfoCallback) => {
    eventCallbacks.add(callback);
  };

  const unsubscribe = (callback: ServerInfoCallback) => {
    eventCallbacks.delete(callback);
  };

  return {
    subscribe,
    unsubscribe,
  };
};
